import { createMutation } from 'Common/utils/network/querykit'

import {
  createImageMeasurement,
  updateImageMeasurement,
  deleteImageMeasurement,
} from '@/api/definitions/iris/measurement'

const useCreateMeasurementMutation = createMutation({
  mutationKey: 'measurement_create',
  mutationFn: createImageMeasurement,
})

const useUpdateMeasurementMutation = createMutation({
  mutationKey: 'measurement_update',
  mutationFn: updateImageMeasurement,
})

const useDeleteMeasurementMutation = createMutation({
  mutationKey: 'measurement_delete',
  mutationFn: deleteImageMeasurement,
})

export { useCreateMeasurementMutation, useUpdateMeasurementMutation, useDeleteMeasurementMutation }
